import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------
// KBT palette — deep navy + teal (matches the brand logo)
// Original primary/secondary preserved; additional tokens for the new
// cinematic landing page are exposed under `navy`, `teal`, and `cream`.
// ----------------------------------------------------------------------

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const NAVY = {
  50: '#EEF0F8',
  100: '#D5D8EC',
  200: '#9A9BC4',
  300: '#5D5D9C',
  400: '#3A3B7A',
  500: '#242258', // brand primary
  600: '#1B1A47',
  700: '#141238',
  800: '#0E0D29',
  900: '#07061A',
};

const TEAL = {
  50: '#E6F2FA',
  100: '#BFDCEF',
  200: '#7FB9DE',
  300: '#3F95CE',
  400: '#1B83C5',
  500: '#0F75BC', // brand secondary
  600: '#0C5E96',
  700: '#0A4D7B',
  800: '#073956',
  900: '#04253B',
};

const CREAM = {
  0: '#FFFFFF',
  50: '#FCFBF7',
  100: '#F7F4EC',
  200: '#EFEAD9',
  300: '#E2D9BD',
};

const GOLD = {
  pale: '#F3E6B5',
  light: '#E2C778',
  main: '#C9A24A',
  dark: '#9A7B2F',
};

const PRIMARY = {
  lighter: '#D1E9FC',
  light: '#76B0F1',
  main: NAVY[500],
  dark: NAVY[700],
  darker: NAVY[900],
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#F9F9F9',
  main: TEAL[500],
  dark: TEAL[700],
  darker: TEAL[900],
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  // Extra brand tokens for the cinematic landing page
  navy: NAVY,
  teal: TEAL,
  cream: CREAM,
  gold: GOLD,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: '#fff',
    default: '#fff',
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
